export default __webpack_public_path__ + "static/media/conversation.d89ce9a4.svg";